import React from "react";

const About = () => {
  return (
    <div id="about">
      <div className="px-4 px-xxl-5 about">
        <div className="spacing">
          <div className="row align-items-start">

            <div className="col-lg-4 mb-5 order-1 order-lg-2">
              <div className="about-assets text-center">
                <img
                  className="w-50"
                  src="./assets/images/3dcosmic.png"
                  alt="3dcosmic"
                />
              </div>
            </div>
            <div className="col-lg-8 mb-5 order-2 order-lg-1">
              <p>
                Cosmic Network is a fully decentralized platform powered by a
                global network of user-operated nodes, ensuring secure,
                censorship-resistant connectivity. Cosmic Network is a fully
                decentralized platform powered by a global network of
                user-operated nodes, ensuring secure, censorship-resistant
                connectivity.
              </p>
              <button onClick={() => {
                window.open("/assets/whitepaper.pdf", "_blank")
              }} className="btn-outline gradient-outline gradient-text mt-5">
                View documentation{" "}
                <img src="./assets/images/Icon.png" alt="External link" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
};

export default About;
